'use client';

import { useState, useEffect, useCallback } from 'react';
import { adminKycApi } from '../api';
import { KYCCounts } from '../types';

interface UseKYCCountsReturn {
  data: KYCCounts | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useKYCCounts(tenantSlug: string): UseKYCCountsReturn {
  const [data, setData] = useState<KYCCounts | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!tenantSlug) return;

    setIsLoading(true);
    setError(null);
    try {
      const result = await adminKycApi.getKYCCounts(tenantSlug);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch KYC counts');
    } finally {
      setIsLoading(false);
    }
  }, [tenantSlug]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, isLoading, error, refetch: fetch };
}
